//Paramètre Saisie horaire
const SAISIE_HORAIRE = Object.freeze({
  HEURES_CENTIEMES: '1',
  HEURES_MINUTES: '2',
})

// Special HTTP-codes
const HTTP_CODES = Object.freeze({
  HTTP_CODE_SESSION_EXPIRED: 401,
  HTTP_CODE_FORBIDDEN: 403,
  HTTP_CODE_NOT_FOUND: 404,
})

// Enum for document types
const DOCUMENT_TYPES = Object.freeze({
  CARD: '2',
  OPERATION: '3',
  SB_AD_CN: '6',
})

// Enum for workorder types
const WORKORDER_TYPES = Object.freeze({
  TL: '1',
  MC: '2',
  DOC: '3',
  KX: '4',
  FS: '5',
  MIS: '6',
})

// Enum for PN types
const PN_TYPES = Object.freeze({
  NON_SUIVI: '0',
  NON_SERIALISE: '1',
  NON_SERIALISE_DATE_PEREMPTION: '2',
  CONSOMMABLE_BATCH_NUMBER: '3',
  CONSOMMABLE_REPARABLE: '4',
  SERIALISE_REPARABLE: '5',
  SERIALISE_NON_REPARABLE: '6',
})

// Display modus for showing a form/document
const FORM_DISPLAY_MODUS = Object.freeze({
  READ: 'READ',
  WRITE: 'WRITE',
  CREATE: 'CREATE',
  EXEC: 'EXEC',
  TERMINATE: 'TERMINATE',
})

// Default display modus for a form/document
const FORM_DISPLAY_MODUS_DEFAULT = FORM_DISPLAY_MODUS.READ

// Standard actions performed on a form
const ACTION_PERFORMED = Object.freeze({
  CREATE: 'CREATE',
  VIEW: 'VIEW',
  UPDATE: 'UPDATE',
  // Cancel current action
  CANCEL: 'CANCEL',
})

const VALUE_TYPE = Object.freeze({
  STRING: 'String',
  BOOLEAN: 'Boolean',
  DATE: 'Date',
  INTEGER: 'Integer',
  /* HH:mm */
  NUMBER_SEMICOLON: 'Number_Semicolon',
  /* H,cc */
  NUMBER_COMMA: 'Number_Comma',
  OBJECT: 'Object',
  NOT_FOUND: undefined,
})

export enum DisplayModus {
  READ = 'READ',
  WRITE = 'WRITE',
  CREATE = 'CREATE',
  EXEC = 'EXEC',
  TERMINATE = 'TERMINATE',
}

export {
  SAISIE_HORAIRE,
  HTTP_CODES,
  DOCUMENT_TYPES,
  WORKORDER_TYPES,
  PN_TYPES,
  FORM_DISPLAY_MODUS,
  FORM_DISPLAY_MODUS_DEFAULT,
  ACTION_PERFORMED,
  VALUE_TYPE,
}
